import React, {Component} from "react"
import PropTypes from "prop-types"
import Validator from "validator"
import {connect} from "react-redux"
import {isEmpty} from "lodash"

import {signup} from "~/actions/authActions"
import {addFlashMessage} from "~/actions/flashMessages"

import {TextFieldGroup} from "~/components/"

class SignupForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      password: "",
      passwordConfirmation: "",
      errors: {},
      isLoading: false
    }
  }

  validateInput(data) {
    let errors = {}

    if (!Validator.isEmail(data.email)) {
      errors.email = "Email is invalid"
    }

    if (Validator.isEmpty(data.email)) {
      errors.email = "Email is required"
    }

    if (Validator.isEmpty(data.password)) {
      errors.password = "Password is required"
    }

    if (Validator.isEmpty(data.passwordConfirmation)) {
      errors.passwordConfirmation = "Password confirmation is required"
    }

    if (!Validator.equals(data.password, data.passwordConfirmation)) {
      errors.passwordConfirmation = "Passwords must match"
    }

    return {
      errors,
      isValid: isEmpty(errors)
    }
  }

  isValid() {
    const {errors, isValid} = this.validateInput(this.state)

    if (!isValid) {
      this.setState({errors})
    }

    return isValid
  }

  onSubmit(event) {
    event.preventDefault()

    if (this.isValid()) {
      this.setState({errors: {}, isLoading: true})
      this.props
        .signup(this.state)
        .then(res => {
          this.props.addFlashMessage({
            type: "success",
            text: "You signed up successfully."
          })
        })
        .catch(err => {
          this.props.addFlashMessage({
            type: "error",
            text: err.response.data.errors[0]
          })
        })
    }
  }

  onEmailChange(email) {
    this.setState({email})
  }

  onPasswordChange(password) {
    this.setState({password})
  }

  onPasswordConfirmationChange(passwordConfirmation) {
    this.setState({passwordConfirmation})
  }

  render() {
    const {email, password, passwordConfirmation, errors} = this.state
    return (
      <form onSubmit={this.onSubmit.bind(this)}>
        <TextFieldGroup
          field="email"
          label="Email"
          value={email}
          error={errors.email}
          onChange={event => this.onEmailChange(event.target.value)}
        />

        <TextFieldGroup
          field="password"
          type="password"
          label="Password"
          value={password}
          error={errors.password}
          onChange={event => this.onPasswordChange(event.target.value)}
        />

        <TextFieldGroup
          field="passwordConfirmation"
          type="password"
          label="Password Confirmation"
          value={passwordConfirmation}
          error={errors.passwordConfirmation}
          onChange={event =>
            this.onPasswordConfirmationChange(event.target.value)
          }
        />

        <button className="">Sign up</button>
      </form>
    )
  }
}

SignupForm.propTypes = {
  signup: PropTypes.func.isRequired
}

export default connect(
  null,
  {signup, addFlashMessage}
)(SignupForm)



// WEBPACK FOOTER //
// ./src/components/forms/SignupForm.js